import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ead5d22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 프리랜서 또는 근로자에요 ")

import { onBeforeMount, ref } from 'vue';

import { setUtmForTracking } from '@/utils/utmHandler'
import Text from '@/components/common/TextComponent.vue'
import { COLOR_SET } from '@/styles/variables'
import { RightAngleBracket } from '@/styles/icon'

import Header from './components/Header.vue'
import Content from './components/Content.vue'
import FreelancerModal from './components/FreelancerModal.vue'


export default /*#__PURE__*/_defineComponent({
  name: 'SelectEntity',
  setup(__props) {

const showFreelancerModal = ref(false)
const showFreelancer = ref(false)

const handleFreelancer = () => {
  showFreelancerModal.value = true
}

onBeforeMount(() => {
  setUtmForTracking()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Header),
      _createVNode(Content),
      (showFreelancer.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "freelancer",
            onClick: handleFreelancer
          }, [
            _createVNode(Text, {
              color: _unref(COLOR_SET).gray015,
              size: "14px"
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["color"]),
            _createVNode(_unref(RightAngleBracket), {
              color: _unref(COLOR_SET).gray015
            }, null, 8, ["color"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (showFreelancerModal.value)
      ? (_openBlock(), _createBlock(FreelancerModal, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (showFreelancerModal.value = false))
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})